import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {GameWordService} from '../../../services/games/game-word/game-word.service';
import {LangSrcService} from '../../../services/lang-src/lang-src.service';
import {LangTgtService} from '../../../services/lang-tgt/lang-tgt.service';
import {AudioService} from '../../../services/audio/audio.service';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {VocabularyItemComponent} from '../../../components/learning/vocabulary-item/vocabulary-item.component';
import {SpinnerComponent} from '../../../components/spinner/spinner.component';

@Component({
  selector: 'app-games-level-vocabulary',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    VocabularyItemComponent,
    SpinnerComponent
  ],
  templateUrl: './games-level-vocabulary.component.html',
  styleUrls: ['./games-level-vocabulary.component.scss']
})
export class GamesLevelVocabularyComponent implements OnInit {

  @Input() level: any;

  loader = true;
  words: any;
  supPinyin = false;

  constructor(
    private activeModal: NgbActiveModal,
    public langSrcSrv: LangSrcService,
    public langTgtSrv: LangTgtService,
    public audioSrv: AudioService,
    private wordSrv: GameWordService
  ) {
  }

  async ngOnInit() {
    this.words = await this.wordSrv.findForVocabulary(this.level.uniqid);
    if (this.langTgtSrv.current.code === 'zh') {
      this.supPinyin = this.words[this.words.length - 1].SupPinyin;
    }
    this.words.pop();
    this.loader = false;
  }

  trackById(index: number, item: any) { return item.id; }

  close() {
    this.activeModal.close();
  }

  col(codeLang: string): string {
    switch (codeLang) {
        case 'zh':
            return this.supPinyin ? 'col-3' : 'col-4';
        case 'en':
        case 'it':
        case 'ru':
        case 'fr':
        case 'toeic':
            return 'col-4';
        default:
            return 'col-3';
    }
}

}
